var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 80,
    viewBox: "0 0 300 80",
    preserveAspectRatio: "xMinYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#005B9F"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 12,
    fill: "url(#lg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,10)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 55 L24 20 L48 20 L60 55 L48 55 L46 44 L26 44 L24 55 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 20,
    width: 14,
    height: 35,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 37,
    r: 10,
    fillOpacity: 0.12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,46)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Inter, Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 26,
    fill: "#071228"
  }, "NehaInfoTech"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.046590a5471257c42d28af286a96b3c0.svg";
export { ForwardRef as ReactComponent };